// React Third Party Library
import { Col, Drawer, Form, Input, Row, Select, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

// Services Library
import { REDUX as REDUX_UTIL, TIME } from "../../../../services/util";

// Components Library
import DrawerCompany from "../DrawerCompany";

const ReviseCompanyThrshldDrawer = (props) => {
  const { isDrawerOpen, setIsDrawerOpen, data } = props;
  const [form] = Form.useForm();

  const [messageApi, contextHolder] = message.useMessage(); 

  useEffect (() => {
    if(isDrawerOpen && Object.values(data).length > 0) {
      form.setFieldsValue({ 
        ...data, billing_date : data?.billing_date ? TIME.dayJS(Number(data.billing_date)) : null
      })
    }
  }, [isDrawerOpen])

  return (
    <>
        {contextHolder}
        <DrawerCompany
          form={form}
          isOpen={isDrawerOpen}
          setIsOpen={setIsDrawerOpen}
          type="Revise"
          //handleSave={createEmployer}
        />
    </>
  );
}

export default ReviseCompanyThrshldDrawer